import { render, staticRenderFns } from "./ItemCommercialTranslationListPage.vue?vue&type=template&id=2ad67f7e&"
import script from "./ItemCommercialTranslationListPage.vue?vue&type=script&lang=ts&"
export * from "./ItemCommercialTranslationListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCommercialTranslationListPage.vue?vue&type=style&index=0&id=2ad67f7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports